import { Typography } from '@mui/material';
import DesignSystem from '../../designSystem';

export function SectionLabel({ children }: { children: React.ReactNode }) {
  return (
    <Typography
      sx={{
        fontSize: 12,
        fontWeight: 700,
        lineHeight: 1.3,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        color: DesignSystem.colors.textSecondary,
        mb: 1,
      }}
    >
      {children}
    </Typography>
  );
}

export default SectionLabel;
